import React from "react";
import banner1 from "../assets/images/banner_1.jpg";
import testimonialimg from "../assets/images/university.png";
import 'remixicon/fonts/remixicon.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import "../assets/css/style.css"

const Home = () => {
    return (
        <div>
            <div className="banner-section">
                <div id="carouselExampleCaptions" className="carousel slide" data-bs-ride="carousel">
                    <div className="carousel-indicators">
                        <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1"></button>
                        <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="1" aria-label="Slide 2"></button>
                        <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="2" aria-label="Slide 3"></button>
                    </div>
                    <div className="carousel-inner">
                        <div className="carousel-item active">
                            <img src={banner1} className="d-block w-100" alt="Banner 1" />
                            <div className="carousel-caption d-none d-md-block">
                                <h5 className="display-4">Empowering Universities to Reach Students Worldwide</h5>
                                <a href="#">Avail FREE Counselling</a>
                            </div>
                        </div>
                        <div className="carousel-item">
                            <img src={banner1} className="d-block w-100" alt="Banner 2" />
                            <div className="carousel-caption d-none d-md-block">
                                <h5 className="display-4">Empowering Universities to Reach Students Worldwide</h5>
                                <a href="#">Avail FREE Counselling</a>
                            </div>
                        </div>
                        <div className="carousel-item">
                            <img src={banner1} className="d-block w-100" alt="Banner 3" />
                            <div className="carousel-caption d-none d-md-block">
                                <h5 className="display-4">Empowering Universities to Reach Students Worldwide</h5>
                                <a href="#">Avail FREE Counselling</a>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            <div class="pt-5 pb-5">
                <div class="container-fluid">
                    <div class="container">
                        <div class="row">
                            <div class="container">
                                <div class="hm-section">
                                    <div class="hm-s-one">
                                        <div>
                                            <h4>Universities</h4>
                                            <p>Empowering Universities to Reach Students Worldwide</p>
                                            <ul>
                                                <li>Free Access to a Global Network</li>
                                                <li>Enhanced Admissions Management</li>
                                                <li>Increase Global Visibility</li>
                                                <li>Safe and Compliant Data Handling</li>

                                            </ul>
                                        </div>
                                    </div>
                                    <div class="hm-s-right">
                                        <div class="hm-s-two">
                                            <a href="javascript:void(0)">Recruiters</a>
                                        </div>
                                        <div class="hm-s-three">
                                            <a href="javascript:void(0)">Recruiters</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="osc-section pt-5 pb-5">
                <div class="container-fluid">
                    <div class="container">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="section-title">
                                    <h2 class="display-5"> Empowering Universities<br />
                                        to Reach Students Worldwide</h2>
                                </div>
                                <p class="text-center">
                                    With GuideUni, universities gain a powerful platform designed to make international student recruitment
                                    seamless and efficient. Our free software solution connects you with a global network of certified
                                    recruiters, enabling you to attract diverse student talent from around the world. Join us to simplify your
                                    recruitment process, improve communication, and expand your institution’s visibility.
                                </p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="howitworks-section ">
                <span class="v-line"></span>
                <div class="container-fluid">
                    <div class="container">
                        <div class="section-title pt-5 bg-fff z-99 po-r pb-5">
                            <h2 class="display-5"> How It Works</h2>
                        </div>

                        <div class="row">
                            <div class="col-md-6 col-sm-12 text-end">

                            </div>
                            <div class="col-md-6 col-sm-12 text-start">
                                <div class="howit-works-list">
                                    <i>1</i>
                                    <h4>Sign Up for Free</h4>
                                    <p>Create a university profile on GuideUni in minutes. Set your specific recruitment needs, preferences,
                                        and criteria to ensure you attract the right students.</p>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6 col-sm-12 text-end">
                                <div class="howit-works-list">
                                    <i>2</i>
                                    <h4>Connect with Qualified Recruiters</h4>
                                    <p>Browse our extensive recruiter network and connect with partners who align with your objectives.
                                        GuideUni’s vetting process ensures that every recruiter meets high standards of integrity and
                                        efficiency.</p>
                                </div>
                            </div>
                            <div class="col-md-6 col-sm-12 text-start">

                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6 col-sm-12 text-end">

                            </div>
                            <div class="col-md-6 col-sm-12 text-start">
                                <div class="howit-works-list">
                                    <i>3</i>
                                    <h4>Manage Applications Seamlessly</h4>
                                    <p>Use GuideUni’s application dashboard to monitor, track, and manage applications from prospective
                                        students. Gain a comprehensive view of the admissions process at any stage.</p>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6 col-sm-12 text-end">
                                <div class="howit-works-list">
                                    <i>4</i>
                                    <h4>Optimize Your Recruitment Strategy</h4>
                                    <p>Access real-time data and reports to refine and improve your international recruitment efforts. Make
                                        data-driven decisions and grow your institution’s global presence.</p>
                                </div>
                            </div>
                            <div class="col-md-6 col-sm-12 text-start">

                            </div>
                        </div>
                        <div class="row">

                            <div class="tab-content" id="myTabContent">
                                <div class="tab-pane fade show active" id="Education" role="tabpanel" aria-labelledby="Education-tab">
                                    <div>

                                    </div>
                                </div>



                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="cr-section mt-5 bg-fff">
                <div class="container-fluid">
                    <div class="container">
                        <div class="section-title">
                            <h2 class="display-5"> Testimonials from Partnered Universities</h2>
                        </div>

                    </div>
                    <div class="row testimonial-section">
                        <div class="container">
                            <div class="row">

                                <div class="col-md-12">
                                    <div id="carouselExampleControls" class="carousel slide" data-bs-ride="carousel">

                                        <div class="carousel-indicators">
                                            <button type="button" data-bs-target="#carouselExampleControls" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
                                            <button type="button" data-bs-target="#carouselExampleControls" data-bs-slide-to="1" aria-label="Slide 2"></button>
                                            <button type="button" data-bs-target="#carouselExampleControls" data-bs-slide-to="2" aria-label="Slide 3"></button>
                                        </div>

                                        <div class="carousel-inner">
                                            <div class="carousel-item active">
                                                <div class="testimonial-panel">
                                                    <div class="container">
                                                        <div class="row">
                                                            <div class="col-md-12 col-sm-12 po-r">
                                                                <div class="testimonial-text">
                                                                    GuideUni has transformed our recruitment process. The platform’s reach and ease of use
                                                                    have allowed us to connect with high-quality candidates we wouldn’t have found otherwise.
                                                                    <div class=" pt-2">--John Smith, Director of Admissions</div>
                                                                </div>
                                                                <div class="client-info text-center">
                                                                    <img src={testimonialimg} alt="university" />
                                                                    <h6>Partnered Universities</h6>


                                                                </div>
                                                            </div>

                                                        </div>
                                                    </div>

                                                </div>

                                            </div>
                                            <div class="carousel-item">
                                                <div class="testimonial-panel">
                                                    <div class="container">
                                                        <div class="row">
                                                            <div class="col-md-12 col-sm-12 po-r">
                                                                <div class="testimonial-text">
                                                                    GuideUni has transformed our recruitment process. The platform’s reach and ease of use
                                                                    have allowed us to connect with high-quality candidates we wouldn’t have found otherwise.
                                                                    <div class=" pt-2">--John Smith, Director of Admissions</div>
                                                                </div>
                                                                <div class="client-info text-center">
                                                                    <img src={testimonialimg} alt="university" />
                                                                    <h6>Partnered Universities</h6>


                                                                </div>
                                                            </div>

                                                        </div>
                                                    </div>

                                                </div>

                                            </div>
                                            <div class="carousel-item">
                                                <div class="testimonial-panel">
                                                    <div class="container">
                                                        <div class="row">
                                                            <div class="col-md-12 col-sm-12 po-r">
                                                                <div class="testimonial-text">
                                                                    GuideUni has transformed our recruitment process. The platform’s reach and ease of use
                                                                    have allowed us to connect with high-quality candidates we wouldn’t have found otherwise.
                                                                    <div class=" pt-2">--John Smith, Director of Admissions</div>
                                                                </div>
                                                                <div class="client-info text-center">
                                                                    <img src={testimonialimg} alt="university" />
                                                                    <h6>Partnered Universities</h6>


                                                                </div>
                                                            </div>

                                                        </div>
                                                    </div>

                                                </div>

                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* <div>
                <div class="container-fluid">
                    <div class="container">
                        <div class="row">
                            <div class="col-md-12 pb-5 pt-5">
                                <div class="section-title">
                                    <h2 class="display-5"> Pricing comparison</h2>
                                </div>
                            </div>

                        </div>
                        <div class="row">
                            <div class="col-md-3 col-sm-12">
                                <div class="price-panel">
                                    <div class="price-header">
                                        <div class="header-text">
                                            <h4>Free</h4>

                                            <span>Forever</span>
                                        </div>
                                    </div>
                                    <div class="price-body">
                                        <ul>
                                            <li>Plan Feature First</li>
                                            <li>Plan Feature Second</li>
                                            <li>Plan Feature</li>
                                            <li>Plan Feature Fourth</li>
                                            <li>Previous Plan</li>
                                        </ul>
                                    </div>
                                    <div class="price-footer">
                                        <a href="javascript:void(0)">Buy</a>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-3 col-sm-12">
                                <div class="price-panel">
                                    <div class="price-header">
                                        <div class="header-text">
                                            <h4>Recruiter</h4>
                                            <span class="price">
                                                <sup>$</sup>
                                                10</span>
                                            <span>Per Month</span>
                                        </div>
                                    </div>
                                    <div class="price-body">
                                        <ul>
                                            <li>Plan Feature First</li>
                                            <li>Plan Feature Second</li>
                                            <li>Plan Feature</li>
                                            <li>Plan Feature Fourth</li>
                                            <li>Previous Plan</li>
                                        </ul>
                                    </div>
                                    <div class="price-footer">
                                        <a href="javascript:void(0)">Buy</a>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-3 col-sm-12">
                                <div class="price-panel">
                                    <div class="price-header">
                                        <div class="header-text">
                                            <h4>Agreegator</h4>
                                            <span class="price">
                                                <sup>$</sup>
                                                25</span>
                                            <span>Per Month</span>
                                        </div>
                                    </div>
                                    <div class="price-body">
                                        <ul>
                                            <li>Plan Feature First</li>
                                            <li>Plan Feature Second</li>
                                            <li>Plan Feature</li>
                                            <li>Plan Feature Fourth</li>
                                            <li>Previous Plan</li>
                                        </ul>
                                    </div>
                                    <div class="price-footer">
                                        <a href="javascript:void(0)">Buy</a>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-3 col-sm-12">
                                <div class="price-panel">
                                    <div class="price-header">
                                        <div class="header-text">
                                            <h4>Universities</h4>
                                            <span class="price">
                                                <sup>$</sup>
                                                45</span>
                                            <span>Per Month</span>
                                        </div>
                                    </div>
                                    <div class="price-body">
                                        <ul>
                                            <li>Plan Feature First</li>
                                            <li>Plan Feature Second</li>
                                            <li>Plan Feature</li>
                                            <li>Plan Feature Fourth</li>
                                            <li>Previous Plan</li>
                                        </ul>
                                    </div>
                                    <div class="price-footer">
                                        <a href="javascript:void(0)">Buy</a>
                                    </div>
                                </div>
                            </div>
                        </div>



                    </div>
                </div>
            </div> */}
            <div class="container-fluid pt-5 pb-5">
                <div class="container">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="section-title text-center">
                                <h2 class="display-5">Join GuideUni Today</h2>
                                <p>Ready to expand your recruitment network and enhance your operations? GuideUni offers everything you need
                                    to succeed in the competitive world of student recruitment. Join our platform and connect with top
                                    universities worldwide to empower your clients.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="need-help">
                <div class="container-fluid">
                    <div class="container pt-3 pb-3">
                        <div class="row">
                            <div class="col-md-8 col-sm-12">
                                <div class="kmd-text">
                                    Get Started with GuideUni
                                </div>
                            </div>
                            <div class="col-md-4 col-sm-12">
                                <ul class="kmd-list">

                                    <li>
                                        <a href="javascript:void(0)">Sign Up for Free</a>
                                    </li>

                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    );
};

export default Home;
